module.exports = __webpack_public_path__ + "img/门诊案件调解-文字信息@2x.7864d0da.png";